// extracted by mini-css-extract-plugin
export default {"button":"styles_button__cLVM3","primary":"styles_primary__FhmI5","secondary":"styles_secondary__4LlWI"};